import {
  PluginShippingRateGroupSchema_2024_05_05,
  PluginShippingRateGroupType_2024_05_05,
} from "./2024-05-05";
export const PluginShippingRateGroupSchema =
  PluginShippingRateGroupSchema_2024_05_05;

export type PluginShippingRateGroupType =
  PluginShippingRateGroupType_2024_05_05;
